import * as model from './model';
import * as lib from './lib';

export const exchangeReturnPolicyEntity = {
  model,
  lib,
};
